import { useState, useRef, useMemo } from 'react';
import { Spin, Tabs } from 'antd';
import SMNav from '../../components/SMNav/SMNav';
import SMHeader from '../../components/SMHeader/SMHeader';
import SMSummary from '../../components/SMSummary/SMSummary';
import SMOrder from '../../components/SMOrder/SMOrder';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import TradeModal from './TradeModal';
import TradeDrawer from './TradeDrawer';
import { headerData, summaryData, orderData } from './SMDetailsData';
import SMDividend from '../../components/SMDividend/SMDividend';
import { useTradeDetilas } from '../../Hooks/useTradeDetails';
import { useSelector, useDispatch } from 'react-redux';
import { usePropertyDetilas } from '../../Hooks/usePropertyDetilas';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';
import { getUsPercentageFormat } from '../../utils/usCurrencyFormatter';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import { fetchPropertyDetailsAction } from '../../store/reducer/propertyDetailSlice';

const SEONDARYOBJ = {
  propertyId: 0,
  propertyName: '',
  label: '',
  cityName: '',
  cityId: 0,
  stateId: 0,
  stateName: '',
  propertyCreatedAt: '',
  images: {},
  propertyType: '',
  dividendYield: 0.0,
  lastTradedPrice: 0,
  allTime: 0.00,
  bids: 0,
  asks: 0,
  likedByLoggedInUser: null
}

const SMDetails = () => {
  const { data } = useSelector((state) => state.propertyDetails);
  const quickBuySecondaryData = useMemo(() => {
    return{
      ...SEONDARYOBJ,
      propertyId: data?.data?.propertyId,
      propertyName: data?.data?.name,
      label: data?.data?.tag,
      cityName: data?.data?.city,
      cityId: 0,
      stateId: 0,
      stateName: data?.data?.state,
      propertyCreatedAt: '',
      images: data?.data?.images,
      propertyType: data?.data?.propertyTypeName,
      dividendYield: data?.data?.tenantStatus?.dividendYield,
      lastTradedPrice: Number(data?.data?.lastPrice),
      allTime: getUsPercentageFormat((100 * (Number(data?.data?.lastPrice) - Number(data?.data?.finance?.perSharePrice))) / Number(data?.data?.finance?.perSharePrice) || 0),
      bids: data?.data?.totalBids,
      asks: data?.data?.totalAsks,
      likedByLoggedInUser: null
    }
  })
  const [openQuickBuy, setOpenQuickBuy] = useState();
  const userProfileData = useSelector((state) => state.userData.userData);
  const {fetchTradeDetails} = useTradeDetilas();
  usePropertyDetilas();
  const { loading } = useSelector((state) => state.tradeDetails);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [isSellOpen, setIsSellOpen] = useState('1');
  const dispatch = useDispatch();
  const formRef = useRef();
  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuy, quickBuySecondaryData, data)
  const handleNotifyMe = async (value) => {
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
              propertyId: value?.id,
              forSecondary: value?.isSecondary,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
          : {
              propertyId: storeNotifyMeData?.id,
              forSecondary: storeNotifyMeData?.isSecondary,
              signUpForNewsletter: newsLetterChecked,
              email: value.email,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
      )
    );
  };
  return (
    <>
      <div className='container-fluid smdetails'>
        <TradeModal 
          quickBuySecondaryOptions = {quickBuySecondaryOptions} 
          open={openQuickBuy} 
          modalState={setOpenQuickBuy} 
          quickBuyPropertyData={quickBuySecondaryData} 
          isSingleTab={false}
          isSell={isSellOpen}
          propertyDetailData={data}
          featchData={async() => {
            setOpenQuickBuy()
            fetchTradeDetails()
            await dispatch(
              fetchPropertyDetailsAction({
                id: data?.data?.propertyId,
              })
            );
          }}
        />
        <TradeDrawer 
          quickBuySecondaryOptions = {quickBuySecondaryOptions} 
          open={openQuickBuy} 
          modalState={setOpenQuickBuy} 
          quickBuyPropertyData={quickBuySecondaryData} 
          isSingleTab={false}
          isSell={isSellOpen}
          propertyDetailData={data}
          featchData={async() => {
            setOpenQuickBuy()
            fetchTradeDetails()
            await dispatch(
              fetchPropertyDetailsAction({
                id: data?.data?.propertyId,
              })
            );
          }}
        />
        <SMNav />

        <Spin spinning={loading}>
          <SMHeader 
            onNotifyClick={(value) => {
              Object.keys(userProfileData).length
                ? handleNotifyMe(value)
                : setStoreNotifyMeData(value) || setOpen(true);
            }}
            propertyDetail={data?.data}
            setIsSellOpen={setIsSellOpen}
            clickAction={setOpenQuickBuy} 
            {...headerData} 
          />
          <div className='mt-44 smdetails__content'>
            <Tabs
              defaultActiveKey='1'
              items={[
                {
                  label: 'Summary',
                  key: '1',
                  children: <SMSummary {...summaryData} />,
                },
                {
                  label: 'Dividend',
                  key: '2',
                  children: <SMDividend />,
                },
                {
                  label: 'Order Book',
                  key: '3',
                  children: <SMOrder {...orderData} />,
                },
              ]}
            />
          </div>
        </Spin>
      </div>
      <MarketFooter />
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
    </>
  );
};

export default SMDetails;
